import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from '../../shared/services/base.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';


@Component({
    selector: 'app-patient-popup',
    templateUrl: './patient-popup.component.html',
    styleUrls: ['./patient-popup.component.scss'],
    standalone: false
})
export class PatientPopupComponent implements OnInit {
  data: any; 
  private _currentResource: string;
  aadharExist: boolean = false;
  // newPrintEnable: any;
  // templateChecked:any;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private appService: AppService,
    private baseService: BaseService,
    private rolePermissionService: RolePermissionService,
    private modal: DialogConfig,
    public dialog: DialogRef,
  ) { }

  ngOnInit() {
    this._currentResource = "patient";
    document.getElementById('visiblePopup').style.display = "none";
    this.data = this.modal.data;
    // this.newPrintEnable=false;
    // this.templateChecked=false;
    // this.getResource();
    this.aadharCheck(this.data)
  }

  aadharCheck(data) {
    this.aadharExist = data?.resource?.[0]?.identity?.patient_identification_details
      ?.some(item => item.identityTypes === "aadhaarNumber") || false;
  }

  // getResource() {
    // if (this.appService && this.appService._currentSessionData && (this.appService._currentSessionData.print_engine == true))

    // if(this.appService.printEngineTemplate && this.appService.printEngineTemplate.length > 0){
    //   this.templateChecked = this.appService.printEngineTemplate.some(x=> x.id === "patientRegistration");
    
    //   this.baseService.init(this._currentResource);
    //   this.baseService.getResourceDef(this._currentResource, (resourceDef) => {
    //     if (resourceDef) {
    //       let capabilityData = resourceDef.capability
    //       capabilityData.forEach(res => {
    //         if(res && res.action && res.action == "print"){
    //             if(res.file_data && res.file_data.template == "patientRegistration"){
    //             if(res.file_data && res.file_data.newPrint && this.templateChecked){
    //             this.newPrintEnable = res.file_data.newPrint;
    //             }
    //           }
    //         }
    //       });
    //     }
    //   })
    // }
    // }
  
  checkPermission(per_name?) {
    let permission=per_name?per_name:'patient_print';
    return this.rolePermissionService.checkAccessPermission(permission, "patient", "patient-registration");
  }
  checkPermissionReg(per_name?) {
    let permission=per_name?per_name:'patient_print';
    let currentUrl = this.router.url;
    if(currentUrl!= undefined && currentUrl.includes("pre_registration"))
    return false
    return this.rolePermissionService.checkAccessPermission(permission, "patient", "patient-registration");
  }

  backToList() {
    this.hide();
    let currentUrl = this.router.url;
    this.router.navigate([this.route.snapshot.queryParams.returnUrl], { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }

  print() {
    var printUrl = "/printengine/api/v1/patient/print?queryId=print&args=facility_id:" + this.appService.getOrganization().org_id + ",reportTemplateId:patientRegistration,contentType:pdf,id:" + this.data.resource[0].id + ",profile:" + this.data.resource[0].id + "&application=patient-registration&filter=false";    
    if(this.appService.checkNativeApp()){
      this.baseService.getFileByUrl(printUrl,false).subscribe((response) => {
        this.baseService.nativeFileHandling(response, "application/pdf", 'Doc_' + this.data.resource[0].id  +"_.pdf");
      });
    }else{
      window.open(printUrl)
    }  
   
    // if(this.newPrintEnable){
     
    // }
    // else{
    //   window.open("/report-management/api/v1/patient/print?queryId=print&args=facility_id:" + this.appService.getOrganization().org_id + ",reportTemplateId:patientRegistration,contentType:pdf,id:" + this.data.resource[0].id + ",profile:" + this.data.resource[0].id + "&application=patient-registration&filter=false")
    // }
  }

  barcodeprint() {
    var printUrl = "/printengine/api/v1/patient/print?queryId=GET_BY_ID&args=id:" + this.appService.getOrganization().org_id + ",reportTemplateId:patientBarCode,contentType:pdf,id:" + this.data.resource[0].id + ",profile:" + this.data.resource[0].id + "&application=patient-registration&filter=false";   
    if(this.appService.checkNativeApp()){
      this.baseService.getFileByUrl(printUrl,false).subscribe((response) => {
        this.baseService.nativeFileHandling(response, "application/pdf", 'BarCode_' + this.data.resource[0].id  +"_.pdf");
      });
    }else{
      window.open(printUrl)
    }
  }
  qrcodeprint() {
    var printUrl = "/printengine/api/v1/patient/print?queryId=GET_BY_ID&args=id:" + this.appService.getOrganization().org_id + ",reportTemplateId:patientQRCode,contentType:pdf,id:" + this.data.resource[0].id + ",profile:" + this.data.resource[0].id + "&application=patient-registration&filter=false";   
    if(this.appService.checkNativeApp()){
      this.baseService.getFileByUrl(printUrl,false).subscribe((response) => {
        this.baseService.nativeFileHandling(response, "application/pdf", 'QrCode_' + this.data.resource[0].id  +"_.pdf");
      });
    }else{
      window.open(printUrl)
    }
  }

  generateAbha(event) {
    this.router.navigate([`/account-management/health-card`], { queryParams: { key: this.data.resource[0].id , event: event, returnUrl: this.router.url } })
    this.dialog.close();
  }

  hide() {
    this.dialog.close();
  }
  backToList_() {
   
    this.dialog.close();

    this.router.navigateByUrl(this.baseService.getUrlParam("returnUrl"));
  }
}